import React from 'react';
import './SummaryCard.css';

function SummaryCard({ title, value, icon, color }) {
  return (
    <div className="summary-card" style={{ borderLeft: `4px solid ${color}` }}>
      <div className="card-icon" style={{ background: `${color}20` }}>
        {icon}
      </div>
      <div className="card-content">
        <p className="card-title">{title}</p>
        <h2 className="card-value">{value}</h2>
      </div>
    </div>
  );
}

export default SummaryCard;